import { makeAutoObservable } from 'mobx'
import { SelectType } from './models'

export interface OknoRoleType {
	// Buhgalteriy: boolean
	// KjMTB: boolean
	// biblioteka: boolean
	// ckb: boolean
	// dekanat: boolean
	id_role_okno: number
	// obshejitie: boolean
	// pole1: boolean
	// pole2: boolean
	// pole3: boolean
	t_fio: string
}

export interface OknoRoleTeacherType extends Object {
	id_AVN_User: any
	id_okno_role_teacher: any
	t_fio: any
	t_fio_pole1:any
	t_fio_pole2:any
	t_fio_pole3:any
	t_fio_pole4:any
	t_fio_pole5:any
	t_fio_pole6:any
	t_fio_pole7:any
	t_fio_pole8:any
	t_fio_pole9:any
	
}

export type OknoPropListType = {
	Description: string
	id_okno_properties: number
	okno_pole: string
	okno_title: string
	sotrudnik: boolean
	visibility: boolean
}

class Accept {
	studentOrTeacher: SelectType[] = [
		{
			value: 1,
			label: 'Сотрудники'
		},
		{
			value: 0,
			label: 'Студенты'
		}
	]

	oknoRole: OknoRoleType[] = [
		{
			// Buhgalteriy: true,
			// KjMTB: true,
			// biblioteka: true,
			// ckb: true,
			// dekanat: true,
			id_role_okno: 2,
			// obshejitie: true,
			// pole1: true,
			// pole2: true,
			// pole3: true,
			t_fio: ''
		}
	]

	oknoRoleTeacher: OknoRoleTeacherType[] = [
		{
			id_AVN_User: 1,
			id_okno_role_teacher: 3,
			t_fio: '',
			t_fio_pole1: true,
			t_fio_pole2: true,
			t_fio_pole3: true,
			t_fio_pole4: true,
			t_fio_pole5: true,
			t_fio_pole6: true,
			t_fio_pole7: true,
			t_fio_pole8: true,
			t_fio_pole9: false
		}
	]

	oknoPropList: OknoPropListType[] = []

	constructor() {
		makeAutoObservable(this)
	}

	newOknoRoles(param: OknoRoleType[]) {
		this.oknoRole = param
	}

	newOknoTeachers(param: OknoRoleTeacherType[]) {
		this.oknoRoleTeacher = param
	}

	newOknoPropList(param: OknoPropListType[]) {
		this.oknoPropList = param
	}
}

export const accept = new Accept()
